export default __webpack_public_path__ + "static/media/Return.94ad55a6.svg";